import React from 'react';

// Types
import { QuestionTypeType } from 'Shared/types/ReviewFormTemplate.type';

// Helpers
import * as ReviewFormTemplatesHelpers from 'Shared/model_helpers/ReviewFormTemplates.helper';

// Components
import ReviewQuestion from '../ReviewQuestion/ReviewQuestion';

type Props = {
  formSlug: string;
  questions;
  answers;
  formData;
};

const ReviewForm = ({ formSlug, questions, answers, formData }: Props) => {
  const filteredQuestions = questions.filter(q => q.get('type') !== QuestionTypeType.TITLE_DESCRIPTION);
  const baseClassName = 'ReviewForm';
  return (
    <div className={baseClassName}>
      {filteredQuestions.map(question => {
        const quetionkey = ReviewFormTemplatesHelpers.getQuestionKey(question);
        return (
          <div className={`${baseClassName}__review__question`} key={`review-question-${formSlug}-${quetionkey}`}>
            <ReviewQuestion question={question} answers={answers} formData={formData} />
          </div>
        );
      })}
    </div>
  );
};

export default ReviewForm;
